import {
  CLOSE_NOTIFICATION,
  CLEAR_NOTIFICATIONS,
  QUEUE_NOTIFICATION,
  LOADING,
  LOADING_DONE,
  SET_NAVBAR,
  HIDE_TOPBAR,
  UPDATE_CUSTOM_VIEWS
} from './actionTypes';
export interface Notification {
  variant: string;
  message: string;
  id?: string;
}
export const newNotification = (notification: Notification) => dispatch => {
  dispatch({
    type: QUEUE_NOTIFICATION,
    payload: notification
  });
};

export const closeNotification = (message: string) => dispatch => {
  dispatch({
    type: CLOSE_NOTIFICATION,
    payload: message
  });
};

export const clearNotifications = () => dispatch => {
  dispatch({
    type: CLEAR_NOTIFICATIONS
  });
};

export const startLoading = () => dispatch => {
  dispatch({
    type: LOADING
  });
};

export const finishLoading = () => dispatch => {
  dispatch({
    type: LOADING_DONE
  });
};

export const setNavbar = (open: boolean) => dispatch => {
  dispatch({
    type: SET_NAVBAR,
    payload: open
  });
};

export const hideTopbar = (hide: boolean) => dispatch => {
  dispatch({
    type: HIDE_TOPBAR,
    payload: hide
  });
};

export const updateCustomViews = (id, bounds) => {
  return {
    type: UPDATE_CUSTOM_VIEWS,
    payload: { id, bounds }
  };
};
